/* @flow */
import { withRouter } from 'react-router';
import { copyProperties } from '../../utils';

const withRouterAndCopiedProperties = (Component: React$ComponentType<*>) => {
  let WrappedComponent = withRouter(Component);
  copyProperties(WrappedComponent, Component);
  return WrappedComponent;
};

export default withRouterAndCopiedProperties;



// WEBPACK FOOTER //
// ./src/ui/components/withRouterAndCopiedProperties.js